import { useState, useEffect } from "react";
import api from "../lib/api";
import PodLayout from "../components/PodLayout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Bell, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function PodNotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/notifications")
      .then(r => setItems(r.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try {
      await api.post(`/notifications/${id}/read`);
      load();
    } catch { toast.error("Failed"); }
  };

  const markAll = async () => {
    try { await api.post("/notifications/read-all"); toast.success("All marked read"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <PodLayout>
      <div className="p-6 md:p-8 max-w-3xl" data-testid="pod-notifications-page">
        <div className="flex items-start justify-between mb-6 gap-4">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-amber-600 font-bold">POD</p>
            <h1 className="text-3xl font-bold text-slate-950" style={{ fontFamily: "'Outfit', sans-serif" }}>Notifications</h1>
          </div>
          {items.some(n => !n.read) && (
            <Button onClick={markAll} variant="outline" className="text-xs" data-testid="pod-notif-mark-all">
              <CheckCircle size={14} className="mr-1" /> Mark all read
            </Button>
          )}
        </div>

        {loading && <p className="text-sm text-slate-500">Loading…</p>}
        {!loading && items.length === 0 && (
          <Card><CardContent className="p-8 text-center">
            <Bell size={32} className="mx-auto text-slate-400" />
            <p className="text-sm text-slate-600 mt-2">No notifications yet.</p>
          </CardContent></Card>
        )}

        <div className="space-y-2">
          {items.map(n => (
            <Card key={n.id} className={n.read ? "opacity-70" : "border-amber-300"} data-testid={`pod-notif-${n.id}`}>
              <CardContent className="p-4 flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-slate-950">{n.title || n.message || "Notification"}</p>
                  {n.body && <p className="text-xs text-slate-600 mt-1 whitespace-pre-wrap">{n.body}</p>}
                  <p className="text-[10px] text-slate-500 mt-1">{n.created_at ? new Date(n.created_at).toLocaleString() : ""}</p>
                </div>
                {!n.read && (
                  <button onClick={() => markRead(n.id)} className="text-xs text-amber-600 hover:text-amber-800 shrink-0" data-testid={`pod-notif-read-${n.id}`}>
                    Mark read
                  </button>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </PodLayout>
  );
}
